import { ReactNode } from 'react';
import { cn } from '@prenuvo/halo';

interface SidePanelOverlayProps {
  children: ReactNode;
  isOpen: boolean;
}

export function SidePanelOverlay({ children, isOpen }: SidePanelOverlayProps) {
  return (
    <div
      className={cn('fixed top-16 right-0 z-40 h-full w-1/2', {
        invisible: !isOpen,
      })}
    >
      {children}
    </div>
  );
}
